import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import api from "../../services/api";

export default function useAllConnections(enabled) {
 const [data, setData] = useState({ companies: [], connections: [] });
 const [loading, setLoading] = useState(Boolean(enabled)), [error, setError] = useState(false), [loaded, setLoaded] = useState(false);
 const active = useRef(false), current = useRef(null);
 const reload = useCallback(() => {
  if (!enabled || !active.current) return Promise.resolve();
  if (current.current) return current.current.promise;
  const cancel = axios.CancelToken.source();
  const request = { cancel };
  current.current = request;
  setLoading(true);
  const config = { timeout: 20000, cancelToken: cancel.token };
  request.promise = Promise.all([api.get("/companies/list", config), api.get("/whatsapp/all", { ...config, params: { session: 0 } })])
   .then(([companies, connections]) => {
    if (!Array.isArray(companies.data) || !Array.isArray(connections.data)) throw new Error("Invalid connections response");
    if (active.current && current.current === request) { setData({ companies: companies.data, connections: connections.data }); setLoaded(true); setError(false); }
   }).catch(err => { if (active.current && current.current === request && !axios.isCancel(err)) setError(true); })
   .finally(() => { if (current.current === request) { current.current = null; if (active.current) setLoading(false); } });
  return request.promise;
 }, [enabled]);
 const refreshAfterMutation = useCallback(async () => {
  const pending = current.current?.promise;
  if (pending) await pending;
  return reload();
 }, [reload]);
 useEffect(() => {
  active.current = enabled;
  if (!enabled) { setData({ companies: [], connections: [] }); setLoaded(false); setLoading(false); return () => { active.current = false; }; }
  reload();
  const refreshVisible = () => { if (!document.hidden) reload(); };
  const timer = setInterval(refreshVisible, 30000);
  window.addEventListener("focus", refreshVisible);
  document.addEventListener("visibilitychange", refreshVisible);
  return () => {
   active.current = false; clearInterval(timer);
   window.removeEventListener("focus", refreshVisible); document.removeEventListener("visibilitychange", refreshVisible);
   if (current.current) current.current.cancel.cancel(); current.current = null;
  };
 }, [enabled, reload]);
 return { ...data, loading, error, loaded, reload, refreshAfterMutation };
}
